import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { StoreConfiguration } from '../../models/store-configuration.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class StoreConfigurationService {

  items: StoreConfiguration[];
  itemEditing: StoreConfiguration;
  private cachedFields: Observable<any>;

  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) { }

  private notifySuccess() {
    this.translate.get(['common.success', 'common.operation_success']).subscribe(res => {
      this.srvNotify.add({ severity: 'info', summary: res['common.success'], detail: res['common.operation_success'] });
    });
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    if (!sort) {
      sort = 'id';
      sort_dir = -1;
    }
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/division-sales-network-configuration' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  getAll() {
    return this.h.get('/koncentro-common/division-sales-network-configuration')
      .map(res => {
        return this.items = res;
      });
  }

  getById(id: number): Observable<any> {
    return this.list(null, null, [{ key: 'id', value: String(id) }]).map(res => {
      const data = (res && res.data) || [];
      return Array.isArray(data) ? data[0] : data;
    });
  }

  delete(record) {
    return this.h.delete('/koncentro-common/division-sales-network-configuration/' + record.id)
      .map(res => {
        this.notifySuccess();
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/division-sales-network-configuration', newData)
      .map(res => {
        newData.id = res.id;
        this.notifySuccess();
      });
  }

  put(newData) {
    return this.h.put('/koncentro-common/division-sales-network-configuration/' + newData.id, newData)
      .map(res => {
        if (this.itemEditing) {
          Object.assign(this.itemEditing, newData);
        }
        this.notifySuccess();
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/DivisionSalesNetworkConfigurationListDto').pipe(
        publishReplay(1),
        refCount()
      );
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/store-configuration/store-configuration.service.ts